// Pieces of the admin pages, as in the admin overview mockup (08): cards, progress bars,
// small switches, buttons, money and times.
import type { ReactNode } from 'react';

export function Panel(props: {
  title: string;
  /** Small grey card title (top row of the overview) or a larger one (lists). */
  small?: boolean;
  side?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      aria-label={props.title}
      className={`flex min-w-0 flex-col gap-2.5 rounded-card border border-line bg-surface p-[18px] ${props.className ?? ''}`}
    >
      <div className="flex items-center justify-between gap-3">
        <h2
          className={`m-0 font-bold ${props.small ? 'text-[14px] text-muted' : 'text-[16px] text-ink'}`}
        >
          {props.title}
        </h2>
        {props.side}
      </div>
      {props.children}
    </section>
  );
}

export function Bar({ value }: { value: number }) {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  return (
    <div aria-hidden="true" className="h-2 rounded-[4px] bg-unrated-bg">
      <div className="h-2 rounded-[4px] bg-accent" style={{ width: `${pct}%` }} />
    </div>
  );
}

export function SmallSwitch(props: {
  checked: boolean;
  label: string;
  onChange: (on: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={props.checked}
      aria-label={props.label}
      disabled={props.disabled}
      onClick={() => props.onChange(!props.checked)}
      className={`box-border inline-flex h-[22px] w-[38px] rounded-[11px] border-0 p-[2px] ${
        props.checked ? 'justify-end bg-accent' : 'justify-start bg-toggle-off'
      }`}
    >
      <span className="h-[18px] w-[18px] rounded-[9px] bg-surface" />
    </button>
  );
}

/** White, bordered, small (the mockup's "Add source", "Copy request"). */
export const smallButton =
  'flex h-[34px] items-center gap-1.5 rounded-[9px] border border-line bg-surface px-3 text-[13px] font-semibold text-ink no-underline disabled:opacity-50';
export const tinyButton =
  'h-[30px] whitespace-nowrap rounded-[8px] border border-line bg-surface px-2.5 text-[12px] font-semibold text-ink disabled:opacity-50';

export function usd(v: number): string {
  return `$${v.toFixed(2)}`;
}

export function when(iso: string | null): string {
  if (!iso) return 'never';
  const d = new Date(iso);
  const today = new Date();
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  if (d.toDateString() === today.toDateString()) return time;
  return `${d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })} ${time}`;
}

export const tableCell = 'border-b border-line-soft px-1.5 py-2';
